export default __webpack_public_path__ + "static/media/led2_up.079a2ad7.svg";